import { NgTemplateOutlet } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, booleanAttribute, NgModule } from '@angular/core';
import * as i4 from 'ng-zorro-antd/core/outlet';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import * as i2 from 'ng-zorro-antd/dropdown';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import * as i3 from 'ng-zorro-antd/icon';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { Router, ActivatedRoute, NavigationEnd, PRIMARY_OUTLET } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, filter, startWith } from 'rxjs/operators';
import { PREFIX } from 'ng-zorro-antd/core/logger';
import * as i1 from '@angular/cdk/bidi';

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
const _c0 = ["*"];
function NzBreadCrumbItemComponent_Conditional_0_ng_template_1_Template(rf, ctx) {}
function NzBreadCrumbItemComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵtemplate(1, NzBreadCrumbItemComponent_Conditional_0_ng_template_1_Template, 0, 0, "ng-template", 2);
    i0.ɵɵelement(2, "span", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const noMenuTpl_r2 = i0.ɵɵreference(4);
    i0.ɵɵproperty("nzDropdownMenu", ctx_r0.nzOverlay);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", noMenuTpl_r2);
  }
}
function NzBreadCrumbItemComponent_Conditional_1_ng_template_0_Template(rf, ctx) {}
function NzBreadCrumbItemComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NzBreadCrumbItemComponent_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 2);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const noMenuTpl_r2 = i0.ɵɵreference(4);
    i0.ɵɵproperty("ngTemplateOutlet", noMenuTpl_r2);
  }
}
function NzBreadCrumbItemComponent_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.nzBreadCrumbComponent.nzSeparator, " ");
  }
}
function NzBreadCrumbItemComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "nz-breadcrumb-separator");
    i0.ɵɵtemplate(1, NzBreadCrumbItemComponent_Conditional_2_ng_container_1_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r0.nzBreadCrumbComponent.nzSeparator);
  }
}
function NzBreadCrumbItemComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
const _forTrack0 = ($index, $item) => $item.url;
function NzBreadCrumbComponent_Conditional_1_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nz-breadcrumb-item")(1, "a", 0);
    i0.ɵɵlistener("click", function NzBreadCrumbComponent_Conditional_1_For_1_Template_a_click_1_listener($event) {
      const breadcrumb_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.navigate(breadcrumb_r2.url, $event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const breadcrumb_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", breadcrumb_r2.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(breadcrumb_r2.label);
  }
}
function NzBreadCrumbComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, NzBreadCrumbComponent_Conditional_1_For_1_Template, 3, 2, "nz-breadcrumb-item", null, _forTrack0);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r2.breadcrumbs);
  }
}
let NzBreadCrumbSeparatorComponent = /*#__PURE__*/(() => {
  class NzBreadCrumbSeparatorComponent {
    static {
      this.ɵfac = function NzBreadCrumbSeparatorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzBreadCrumbSeparatorComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzBreadCrumbSeparatorComponent,
        selectors: [["nz-breadcrumb-separator"]],
        hostAttrs: [1, "ant-breadcrumb-separator"],
        exportAs: ["nzBreadcrumbSeparator"],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function NzBreadCrumbSeparatorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return NzBreadCrumbSeparatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
/**
 * https://angular.io/errors/NG3003
 * An intermediate interface for {@link NzBreadCrumbComponent} & {@link NzBreadCrumbItemComponent}
 */
class NzBreadcrumb {}

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzBreadCrumbItemComponent = /*#__PURE__*/(() => {
  class NzBreadCrumbItemComponent {
    constructor(nzBreadCrumbComponent) {
      this.nzBreadCrumbComponent = nzBreadCrumbComponent;
    }
    static {
      this.ɵfac = function NzBreadCrumbItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzBreadCrumbItemComponent)(i0.ɵɵdirectiveInject(NzBreadcrumb));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzBreadCrumbItemComponent,
        selectors: [["nz-breadcrumb-item"]],
        inputs: {
          nzOverlay: "nzOverlay"
        },
        exportAs: ["nzBreadcrumbItem"],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 5,
        vars: 2,
        consts: [["noMenuTpl", ""], ["nz-dropdown", "", 1, "ant-breadcrumb-overlay-link", 3, "nzDropdownMenu"], [3, "ngTemplateOutlet"], ["nz-icon", "", "nzType", "down"], [4, "nzStringTemplateOutlet"], [1, "ant-breadcrumb-link"]],
        template: function NzBreadCrumbItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, NzBreadCrumbItemComponent_Conditional_0_Template, 3, 2, "span", 1)(1, NzBreadCrumbItemComponent_Conditional_1_Template, 1, 1, null, 2)(2, NzBreadCrumbItemComponent_Conditional_2_Template, 2, 1, "nz-breadcrumb-separator")(3, NzBreadCrumbItemComponent_ng_template_3_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!!ctx.nzOverlay ? 0 : 1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.nzBreadCrumbComponent.nzSeparator ? 2 : -1);
          }
        },
        dependencies: [NgTemplateOutlet, NzBreadCrumbSeparatorComponent, NzDropDownModule, i2.NzDropDownDirective, NzIconModule, i3.NzIconDirective, NzOutletModule, i4.NzStringTemplateOutletDirective],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return NzBreadCrumbItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NzBreadCrumbComponent = /*#__PURE__*/(() => {
  class NzBreadCrumbComponent {
    constructor(injector, cdr, elementRef, renderer, directionality) {
      this.injector = injector;
      this.cdr = cdr;
      this.elementRef = elementRef;
      this.renderer = renderer;
      this.directionality = directionality;
      this.nzAutoGenerate = false;
      this.nzSeparator = '/';
      this.nzRouteLabel = 'breadcrumb';
      this.nzRouteLabelFn = label => label;
      this.nzRouteFn = route => route;
      this.breadcrumbs = [];
      this.dir = 'ltr';
      this.destroy$ = new Subject();
    }
    ngOnInit() {
      if (this.nzAutoGenerate) {
        this.registerRouterChange();
      }
      this.directionality.change?.pipe(takeUntil(this.destroy$)).subscribe(direction => {
        this.dir = direction;
        this.prepareComponentForRtl();
        this.cdr.detectChanges();
      });
      this.dir = this.directionality.value;
      this.prepareComponentForRtl();
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    navigate(url, e) {
      e.preventDefault();
      this.injector.get(Router).navigateByUrl(url);
    }
    registerRouterChange() {
      try {
        const router = this.injector.get(Router);
        const activatedRoute = this.injector.get(ActivatedRoute);
        router.events.pipe(filter(e => e instanceof NavigationEnd), takeUntil(this.destroy$), startWith(true) // trigger initial render
        ).subscribe(() => {
          this.breadcrumbs = this.getBreadcrumbs(activatedRoute.root);
          this.cdr.markForCheck();
        });
      } catch (e) {
        throw new Error(`${PREFIX} You should import RouterModule if you want to use 'NzAutoGenerate'.`);
      }
    }
    getBreadcrumbs(route, url = '', breadcrumbs = []) {
      const children = route.children;
      // If there's no sub root, then stop the recurse and returns the generated breadcrumbs.
      if (children.length === 0) {
        return breadcrumbs;
      }
      for (const child of children) {
        if (child.outlet === PRIMARY_OUTLET) {
          // Only parse components in primary router-outlet (in another word, router-outlet without a specific name).
          // Parse this layer and generate a breadcrumb item.
          const routeUrl = child.snapshot.url.map(segment => segment.path).filter(path => path).join('/');
          // Do not change nextUrl if routeUrl is falsy. This happens when it's a route lazy loading other modules.
          const nextUrl = routeUrl ? `${url}/${routeUrl}` : url;
          const breadcrumbLabel = this.nzRouteLabelFn(child.snapshot.data[this.nzRouteLabel]);
          const shapedUrl = this.nzRouteFn(nextUrl);
          // If have data, go to generate a breadcrumb for it.
          if (routeUrl && breadcrumbLabel) {
            const breadcrumb = {
              label: breadcrumbLabel,
              params: child.snapshot.params,
              url: shapedUrl
            };
            breadcrumbs.push(breadcrumb);
          }
          return this.getBreadcrumbs(child, nextUrl, breadcrumbs);
        }
      }
      return breadcrumbs;
    }
    prepareComponentForRtl() {
      if (this.dir === 'rtl') {
        this.renderer.addClass(this.elementRef.nativeElement, 'ant-breadcrumb-rtl');
      } else {
        this.renderer.removeClass(this.elementRef.nativeElement, 'ant-breadcrumb-rtl');
      }
    }
    static {
      this.ɵfac = function NzBreadCrumbComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzBreadCrumbComponent)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.Directionality));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzBreadCrumbComponent,
        selectors: [["nz-breadcrumb"]],
        hostAttrs: [1, "ant-breadcrumb"],
        inputs: {
          nzAutoGenerate: [2, "nzAutoGenerate", "nzAutoGenerate", booleanAttribute],
          nzSeparator: "nzSeparator",
          nzRouteLabel: "nzRouteLabel",
          nzRouteLabelFn: "nzRouteLabelFn",
          nzRouteFn: "nzRouteFn"
        },
        exportAs: ["nzBreadcrumb"],
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NzBreadcrumb,
          useExisting: NzBreadCrumbComponent
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 2,
        vars: 1,
        consts: [[3, "click"]],
        template: function NzBreadCrumbComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
            i0.ɵɵtemplate(1, NzBreadCrumbComponent_Conditional_1_Template, 2, 0);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.nzAutoGenerate && ctx.breadcrumbs.length ? 1 : -1);
          }
        },
        dependencies: [NzBreadCrumbItemComponent],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return NzBreadCrumbComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzBreadCrumbModule = /*#__PURE__*/(() => {
  class NzBreadCrumbModule {
    static {
      this.ɵfac = function NzBreadCrumbModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzBreadCrumbModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NzBreadCrumbModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [NzBreadCrumbComponent, NzBreadCrumbItemComponent]
      });
    }
  }
  return NzBreadCrumbModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzBreadCrumbComponent, NzBreadCrumbItemComponent, NzBreadCrumbModule, NzBreadCrumbSeparatorComponent };
